import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useI18n } from '../i18n';
import { Lock, CheckCircle2, AlertCircle } from 'lucide-react';
import './coming-soon.css';

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const { resetPassword } = useAuth();
  const { t } = useI18n();
  const navigate = useNavigate();
  const r = t.reset;

  const [pwd, setPwd] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const errText = (code) => t.connect.errors[code] || t.connect.errors.ERROR;

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (pwd.length < 8) { setError(t.connect.errors.PASSWORD_SHORT); return; }
    if (pwd !== confirm) { setError(r.mismatch); return; }
    setLoading(true);
    const res = await resetPassword(token, pwd);
    setLoading(false);
    if (res.ok) setDone(true);
    else setError(errText(res.code));
  };

  const inputWrap = { display: 'flex', alignItems: 'center', gap: 10, padding: '0 14px', border: '1px solid rgba(255,255,255,0.12)', borderRadius: 12, background: 'rgba(255,255,255,0.03)' };
  const inputStyle = { flex: 1, border: 0, outline: 0, background: 'transparent', color: '#fff', fontSize: 15, padding: '13px 0', fontFamily: 'inherit' };

  return (
    <div className="cs-page" data-testid="reset-page">
      <div className="cs-card" style={{ textAlign: 'left' }}>
        {!token ? (
          <div style={{ textAlign: 'center' }}>
            <AlertCircle size={40} color="#fca5a5" style={{ margin: '0 auto 14px', display: 'block' }} />
            <h1 className="cs-title" style={{ fontSize: 'clamp(22px,6vw,28px)' }}>{r.invalidTitle}</h1>
            <p className="cs-subtitle">{r.invalidText}</p>
            <Link to="/" className="cs-home" data-testid="reset-invalid-home">{r.backHome}</Link>
          </div>
        ) : done ? (
          <div data-testid="reset-success" style={{ textAlign: 'center' }}>
            <CheckCircle2 size={44} color="#22c55e" style={{ margin: '0 auto 14px', display: 'block' }} />
            <h1 className="cs-title" style={{ fontSize: 'clamp(22px,6vw,28px)' }}>{r.success}</h1>
            <button onClick={() => navigate('/')} className="cs-home" data-testid="reset-success-login" style={{ marginTop: 18 }}>{r.successCta}</button>
          </div>
        ) : (
          <>
            <div style={{ textAlign: 'center', marginBottom: 22 }}>
              <img src="/assets/hitmax_icon.webp" alt="HitMax" style={{ width: 72, height: 72, borderRadius: 18, border: '2px solid rgba(255,255,255,0.9)', margin: '0 auto 14px', display: 'block' }} draggable={false} />
              <h1 className="cs-title" style={{ fontSize: 'clamp(22px,6vw,28px)' }}>{r.title}</h1>
              <p className="cs-subtitle" style={{ marginTop: 10 }}>{r.subtitle}</p>
            </div>
            {error && (
              <div data-testid="reset-error" style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '11px 14px', marginBottom: 14, borderRadius: 10, border: '1px solid rgba(239,68,68,0.4)', background: 'rgba(239,68,68,0.1)', color: '#fca5a5', fontSize: 13.5 }}>
                <AlertCircle size={16} style={{ flex: '0 0 auto' }} /> <span>{error}</span>
              </div>
            )}
            <form onSubmit={submit} style={{ display: 'grid', gap: 12 }}>
              <div style={inputWrap}>
                <Lock size={17} color="#8b93a7" />
                <input data-testid="reset-password" type="password" placeholder={r.placeholder} value={pwd} onChange={(e) => setPwd(e.target.value)} required style={inputStyle} />
              </div>
              <div style={inputWrap}>
                <Lock size={17} color="#8b93a7" />
                <input data-testid="reset-confirm" type="password" placeholder={r.confirmPlaceholder} value={confirm} onChange={(e) => setConfirm(e.target.value)} required style={inputStyle} />
              </div>
              <button type="submit" disabled={loading} data-testid="reset-submit" className="btn-gold" style={{ marginTop: 6, padding: '14px', borderRadius: 12, fontSize: 15, opacity: loading ? 0.7 : 1 }}>{loading ? r.loading : r.submit}</button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
